import { render, staticRenderFns } from "./PaymentDetailsHistory.vue?vue&type=template&id=155d06a4"
import script from "./PaymentDetailsHistory.vue?vue&type=script&lang=js"
export * from "./PaymentDetailsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports